var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlack2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Apps/Integrations/Slack@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "-3.16786323e-16 24 18.3607233 24 18.3607233 4.87706613e-16 -3.16786323e-16 4.87706613e-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "-3.16786323e-16 24 18.3607233 24 18.3607233 4.87706613e-16 -3.16786323e-16 4.87706613e-16"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Apps/Integrations/Slack",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    fill: "#D8DDE4",
    opacity: 0.188313802,
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Slack_Logo_Pre_2019",
    transform: "translate(5, 4.7249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(2.8266, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7374007,1.47857665 C12.3725645,0.354986158 11.1664798,-0.259868072 10.0436344,0.105343134 C8.92059223,0.470357461 8.30603805,1.67703104 8.67107103,2.80042465 L14.1991069,19.8171012 C14.5787018,20.866665 15.7119767,21.4565156 16.7997947,21.1432805 C17.9344471,20.8164608 18.6261403,19.6107716 18.2640591,18.4958438 C18.2502842,18.4533179 12.7374007,1.47857665 12.7374007,1.47857665",
    id: "Fill-1",
    fill: "#DFA22F",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-3-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17181817,4.26304139 C3.80678519,3.13964778 2.60070047,2.52479355 1.47785509,2.88980787 C0.354812923,3.2548222 -0.259741255,4.46149578 0.105291726,5.58508626 L5.63332757,22.6017628 C6.01292252,23.6513267 7.14619741,24.2411772 8.23401537,23.9277453 C9.36866776,23.6011224 10.060361,22.3954332 9.69827975,21.2803086 C9.68450492,21.2379795 4.17181817,4.26304139 4.17181817,4.26304139",
    id: "Fill-3",
    fill: "#3CB187",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M22.5222196,15.5717916 C23.6452618,15.2067773 24.2596192,14.0001037 23.894783,12.8765132 C23.5299468,11.7531196 22.3238621,11.1382654 21.2010167,11.5032797 L4.19264439,17.0342115 C3.14359274,17.4137949 2.55403004,18.5476231 2.86711223,19.6359722 C3.19377247,20.7711786 4.39887327,21.4632095 5.51325697,21.1009515 C5.55576216,21.0871699 22.5222196,15.5717916 22.5222196,15.5717916",
    id: "Fill-5",
    fill: "#CE1E5B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73749836,20.3780105 C8.84460108,20.018115 10.2714766,19.5542672 11.8026473,19.0565562 C11.4429275,17.948913 10.9793061,16.5211439 10.4816412,14.9890287 L6.41629543,16.3110736 L7.73749836,20.3780105",
    id: "Fill-6",
    fill: "#392538",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0, 2.8281)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3032777,14.7652809 C17.8401551,14.265798 19.2686049,13.8013596 20.3684266,13.4438267 C20.0087068,12.3361834 19.5448886,10.9080205 19.0472237,9.37551163 L14.981878,10.6975565 L16.3032777,14.7652809",
    id: "Fill-7",
    fill: "#BB242A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7391137,4.17376215 C20.8619591,3.80874782 21.4765133,2.60207425 21.1116771,1.47848376 C20.7468409,0.35509015 19.5407562,-0.25976408 18.417714,0.105250247 L1.40934171,5.63618201 C0.360290053,6.01576541 -0.229272648,7.14959362 0.0840063302,8.23794271 C0.410469788,9.37314908 1.61557058,10.06518 2.73015107,9.702922 C2.77245947,9.68914044 19.7391137,4.17376215 19.7391137,4.17376215",
    id: "Fill-9",
    fill: "#72C5CD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.95360533,11.8082458 C6.06070805,11.4483504 7.48797717,10.9843057 9.01934464,10.4865947 C8.52010546,8.94877007 8.05589371,7.51962282 7.69853527,6.41906722 L3.63220562,7.74130898 L4.95360533,11.8082458",
    id: "Fill-11",
    fill: "#238C73",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5191879,9.02378111 C15.0564588,8.5241013 16.4851054,8.0596629 17.5851239,7.70193311 C17.085688,6.16391157 16.6214762,4.73437057 16.263921,3.63361808 L12.1977881,4.95585984 L13.5191879,9.02378111",
    id: "Fill-12",
    fill: "#62803A",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack2X);
export default __webpack_public_path__ + "static/media/Slack@2x.e13f0b9cd35a35ee3f8577bb4157e5a5.svg";
export { ForwardRef as ReactComponent };